// Imports
import React from 'react'
import Delboni from 'assets/LogosBrancas/01_Delboni.svg'
import Lavoisier from 'assets/LogosBrancas/02_Lavoisier.svg'
import Bronstein from 'assets/LogosBrancas/03_Bronstein.svg'
import Cdpi from 'assets/LogosBrancas/04_CDPI.svg'
import Alta from 'assets/LogosBrancas/05_Alta.svg'
import SalomaoZoppi from 'assets/LogosBrancas/06_SalomaoZoppi.svg'
import Image from 'assets/LogosBrancas/07_Image.svg'
import LaminaRJ from 'assets/LogosBrancas/08_LaminaRJ.svg'
import SergioFranco from 'assets/LogosBrancas/09_SergioFranco.svg'
import Exame from 'assets/LogosBrancas/10_Exame.svg'
import SaoCamilo from 'assets/LogosBrancas/11_SaoCamilo.svg'
import CedicCedilab from 'assets/LogosBrancas/12_CedicCedilab.svg'
import MedImagem from 'assets/LogosBrancas/13_MedImagem.svg'
import LaminaSul from 'assets/LogosBrancas/14_LaminaSul.svg'
import Cerpe from 'assets/LogosBrancas/15_Cerpe.svg'
import Leme from 'assets/LogosBrancas/16_Leme.svg'
import Frischman from 'assets/LogosBrancas/17_Frischman.svg'
import Cytolab from 'assets/LogosBrancas/18_Cytolab.svg'
import Deliberato from 'assets/LogosBrancas/19_Deliberato.svg'
import Itulab from 'assets/LogosBrancas/20_Itulab.svg'
import Previlab from 'assets/LogosBrancas/21_Previlab.svg'
import Atalaia from 'assets/LogosBrancas/22_Atalaia.svg'
import Alvaro from 'assets/LogosBrancas/23_Alvaro.svg'
import ValeClin from 'assets/LogosBrancas/24_ValeClin.svg'
import Ghanem from 'assets/LogosBrancas/25_Ghanem.svg'
import Gaspar from 'assets/LogosBrancas/26_Gaspar.svg'
import LabOswaldoCruz from 'assets/LogosBrancas/27_LabOswaldoCruz.svg'
import LabPasteur from 'assets/LogosBrancas/28_LabPasteur.svg'
import VitalBrasil from 'assets/LogosBrancas/29_VitalBrasil.svg'
import Exame1 from 'assets/LogosBrancas/30_Exame.svg'
import Bioclinico from 'assets/LogosBrancas/31_Bioclinico.svg'
import Antonello from 'assets/LogosBrancas/32_Antonello.svg'
import Lunav from 'assets/LogosBrancas/33_Lunav.svg'
import Hemat from 'assets/LogosBrancas/34_Hemat.svg'
import PadraoRibeirao from 'assets/LogosBrancas/35_PadraoRibeirao.svg'
import GeneOne from 'assets/LogosBrancas/36_GeneOne.svg'
import Cec from 'assets/LogosBrancas/37_Cec.svg'
import Lustosa from 'assets/LogosBrancas/38_Lustosa.svg'
import GilsonCidrim from 'assets/LogosBrancas/39_GilsonCidrim.svg'
import SenhorDosPassos from 'assets/LogosBrancas/40_SenhordosPassos.svg'
import Bacellar from 'assets/LogosBrancas/41_Bacellar.svg'
import DasaGenomica from 'assets/LogosBrancas/42_DasaGenomica.svg'
import { LogoCarouselContainer, LogoItem, LogoRow } from './styles'

const logos = [
    Deliberato,
    Itulab,
    Previlab,
    Atalaia,
    Alvaro,
    ValeClin,
    Ghanem,
    Gaspar,
    LabOswaldoCruz,
    LabPasteur,
    VitalBrasil,
    Exame1,
    Bioclinico,
    Antonello,
    Lunav,
    Hemat,
    PadraoRibeirao,
    GeneOne,
    Cec,
    Lustosa,
    GilsonCidrim,
    SenhorDosPassos,
    Bacellar,
    DasaGenomica,
    Delboni,
    Lavoisier,
    Bronstein,
    Cdpi,
    Alta,
    SalomaoZoppi,
    Image,
    LaminaRJ,
    SergioFranco,
    Exame,
    SaoCamilo,
    CedicCedilab,
    MedImagem,
    LaminaSul,
    Cerpe,
    Leme,
    Frischman,
    Cytolab,
]

const LogoCarousel = () => (
    <LogoCarouselContainer>
        <LogoRow>
            {logos.map((logo, index) => (
                <LogoItem key={index}>
                    <img alt={`Logo ${index + 1}`} src={logo} />
                </LogoItem>
            ))}
            {logos.map((logo, index) => (
                <LogoItem key={`repeat-${index}`}>
                    <img alt={`Logo repetida ${index + 1}`} src={logo} />
                </LogoItem>
            ))}
        </LogoRow>
    </LogoCarouselContainer>
)

export default LogoCarousel
